import { render, staticRenderFns } from "./ArticleGridBNG.vue?vue&type=template&id=ed145bf0&scoped=true"
import script from "./ArticleGridBNG.vue?vue&type=script&lang=js"
export * from "./ArticleGridBNG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed145bf0",
  null
  
)

export default component.exports